// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getNextAvailableDates = (state: ReduxStateShared) => state.nextAvailableDates.dates;
export const getLastRequestAttemptedAt = (state: ReduxStateShared) => state.nextAvailableDates.lastRequestAttemptedAt;
export const getRequestAttemptCount = (state: ReduxStateShared) => state.nextAvailableDates.requestAttemptCount;
